<div class="settlement-detail-reject-motivation" data-cy="settlement-detail-reject-motivation">
    <div class="settlement-detail-reject-motivation-description">
        <div class="settlement-detail-body-output-field-label"
             data-cy="settlement-detail-body-output-field-label-rejection-motivation">{{LABEL_REASON}}
        </div>
        <div class="settlement-detail-body-output-field-value settlement-detail-box-border"
             data-cy="settlement-detail-body-output-field-value-rejection-motivation">{{$safeNavigationMigration(agreementDecision?.decisionReason) | undefinedValue}}</div>
    </div>
    <div class="settlement-detail-by">
        <div class="settlement-detail-body-output-field-label"
             data-cy="settlement-detail-body-output-field-label-rejection-by-email">{{LABEL_REJECTED}}
        </div>
        <div class="settlement-detail-body-output-field-value settlement-detail-body-output-field-value-email"
             data-cy="settlement-detail-body-output-field-value-rejection-by-email">{{$safeNavigationMigration(agreementDecision?.decidedBy) | prettyPrintUpdatedBy | undefinedValue}}</div>
    </div>
</div>
